// This file was auto-generated by Fern from our API Definition.
/** Location of the discriminator relative to the union type */
const UnionDiscriminatorContextValues = {
    /**
     * Discriminator is within the union data itself (e.g., data.type field) */
    Data: "data",
    /**
     * Discriminator is at the protocol level (e.g., SSE event field, HTTP path) */
    Protocol: "protocol",
};
export const UnionDiscriminatorContext = Object.assign(Object.assign({}, UnionDiscriminatorContextValues), { _visit: (value, visitor) => {
        switch (value) {
            case UnionDiscriminatorContext.Data:
                return visitor.data();
            case UnionDiscriminatorContext.Protocol:
                return visitor.protocol();
            default:
                return visitor._other();
        }
    } });
